// Transform a URL to use an API subdomain based on configuration
export function transformWithApiSubdomain(url: string, useApiSubdomain: boolean, apiSubdomain: string = 'api'): string {
  // If the feature is disabled, return the original URL
  if (!useApiSubdomain) {
    return url;
  }

  try {
    // Parse the URL to manipulate its components
    const urlObj = new URL(url);

    // Check if the URL already has a subdomain matching our api subdomain
    if (urlObj.hostname.startsWith(`${apiSubdomain}.`)) {
      return url;
    }

    // Add the API subdomain to the hostname
    urlObj.hostname = `${apiSubdomain}.${urlObj.hostname}`;

    return urlObj.toString();
  } catch (e) {
    // If URL parsing fails (e.g., for relative URLs), return the original URL
    // This shouldn't happen since we're expecting absolute URLs here
    console.error(`Failed to transform URL with API subdomain: ${url}`, e);
    return url;
  }
}
